import React from 'react'
import { withStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete'
import CancelIcon from '@material-ui/icons/Cancel'
import IconButton from '@material-ui/core/IconButton'
import Checkbox from '@material-ui/core/Checkbox'
import _ from 'lodash';

const styles = theme => ({
    deleteIcon: {
        position: 'absolute',
        display: 'inline-block',
        width: 24,
        height:24,
        backgroundColor: '#e1518c',
        borderRadius: 12,
        top: -8,
        right: -12,
        fontSize: 22,
        color: '#fff',
        textAlign: 'center',
        lineHeight: '24px',
        cursor: 'pointer'
    },
    li: {
        display: 'flex',
        alignItems: 'center'
    }
});
class PerItem extends React.Component {
    render() {
        const itemStyle = {
            border: `1px solid #EADAEA`,
            borderRadius: 5,
            paddingLeft: 13,
            marginRight:16,
            position: 'relative'
        }
        const {classes,items = [],handleShowIcon,currentName, handleHideIcon, checkIds, onDelete, onChangePermission,isHasPermission} = this.props
        const tempItems = items.reduce((array,item) => {
            const name = item.name.split('_')[0]
            const action = item.name.split('_')[1]
            const isShow = false
            let index = array.findIndex(n => n.name === name)
            if (index > -1) {
                array[index].children.push({action,id: item.id})
                return array
            } else {
                return [...array,{isShow,name,children:[{action,id: item.id}]}]
            }
        },[])
        return (
            <ul style={{overflow: 'auto'}}>
                {tempItems.map((items,index) => {
                    const isShow = currentName === items.name
                    return <li className={classes.li} key={index}>
                        <h4 style={{marginRight:20}}>{items.name}：</h4>
                        {items.children.map((item,i) => {
                            return <span style={isShow ? itemStyle : null} key={i}>
                                {isShow && <span onClick={() =>onDelete(item.id)} className={classes.deleteIcon}>×</span>}
                                {item.action}
                                <Checkbox checked={_.includes(checkIds, item.id)} onChange={() =>onChangePermission(item.id)} />
                            </span>
                        })}
                        {isHasPermission && <IconButton onClick={isShow ? ()=>handleHideIcon(items.name) : ()=>handleShowIcon(items.name)}>{isShow ? <CancelIcon />: <DeleteIcon />}</IconButton>}
                    </li>
                })}
            </ul>
            
        )
    }
}

export default withStyles(styles)(PerItem);


// WEBPACK FOOTER //
// ./src/pages/home/routes/permission/components/perItem.js